export const Types = {
    GET_MAILGROUPS: "GET_MAILGROUPS",
    SET_MAILGROUPS: "SET_MAILGROUPS",

    ADD_MAILGROUP: "ADD_MAILGROUP",
    UPDATE_MAILGROUP: "UPDATE_MAILGROUP",
    DELETE_MAILGROUP: "DELETE_MAILGROUP",

    ADD_MAILADDRESSES: "ADD_MAILADDRESSES",
    UPDATE_MAILADDRESSES: "UPDATE_MAILADDRESSES",
    DELETE_MAILADDRESS: "DELETE_MAILADDRESS",

    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getMailGroups = (payload) => ({
    type: Types.GET_MAILGROUPS,
    payload: payload,
});

export const setMailGroups = (payload) => ({
    type: Types.SET_MAILGROUPS,
    payload: payload,
});

export const addMailGroup = (payload) => ({
    type: Types.ADD_MAILGROUP,
    payload: payload,
});

export const updateMailGroup = (payload) => ({
    type: Types.UPDATE_MAILGROUP,
    payload: payload,
});

export const deleteMailGroup = (payload) => ({
    type: Types.DELETE_MAILGROUP,
    payload: payload,
});

export const addMailAddresses = (payload) => ({
    type: Types.ADD_MAILADDRESSES,
    payload: payload,
});

export const updateMailAddresses = (payload) => ({
    type: Types.UPDATE_MAILADDRESSES,
    payload: payload,
});

export const deleteMailAddress = (payload) => ({
    type: Types.DELETE_MAILADDRESS,
    payload: payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
